import { Helmet } from 'react-helmet-async';
import LandingHeader from '../landing/LandingHeader';
import LandingFooter from '../landing/LandingFooter';
import { IconQuestion } from '../landing/LandingIcons';

export default function TermsOfService() {
    return (
        <>
            <Helmet>
                <title>이용약관 - GrowFit</title>
                <meta name="description" content="GrowFit AI 실습 플랫폼 서비스 이용약관입니다. 회사와 회원 간의 권리·의무 및 책임사항을 규정합니다." />
                <link rel="canonical" href="https://growfit.kr/terms" />
                <meta property="og:title" content="이용약관 - GrowFit" />
                <meta property="og:description" content="GrowFit AI 실습 플랫폼 서비스 이용약관." />
                <meta property="og:url" content="https://growfit.kr/terms" />
                <meta property="og:type" content="website" />
            </Helmet>

            <div className="landing">
                <LandingHeader />

                <main className="landing__main landing__main--narrow" style={{ paddingTop: 40 }}>
                    <section className="landing-legal">
                        <div className="landing-legal__head">
                            <h1 className="landing-legal__title">약관</h1>
                            <span
                                className="landing-legal__help"
                                title="서비스 이용약관 안내"
                                aria-label="서비스 이용약관 안내"
                            >
                                <IconQuestion size={20} />
                            </span>
                        </div>

                        <div className="landing-legal__body">
                            <p className="landing-legal__meta">시행일: 2026년 03월 05일</p>

                            <h2>제1조 (목적)</h2>
                            <p>본 약관은 GrowFit(이하 "회사")이 제공하는 AI 실습 플랫폼 서비스(이하 "서비스")의 이용과 관련하여 회사와 회원 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.</p>

                            <h2>제2조 (서비스 내용)</h2>
                            <p>회사는 AI 실습 및 교육을 위한 다음과 같은 기능을 제공합니다.</p>
                            <ul>
                                <li>LLM 기반 실습(채팅/세션 실행)</li>
                                <li>모델 선택 및 파라미터 설정</li>
                                <li>프롬프트·에이전트 구성 및 실행</li>
                                <li>지식베이스(RAG) 문서 업로드 및 검색</li>
                                <li>비교 실험(A/B), 학습 기록 관리</li>
                                <li>사용량(토큰·호출·비용) 통계 제공</li>
                                <li>클래스·학생·조직 관리 기능</li>
                            </ul>
                            <p>서비스 기능은 정책에 따라 변경될 수 있습니다.</p>

                            <h2>제3조 (회원가입 및 이용계약)</h2>
                            <ul>
                                <li>회원가입은 약관 동의 후 회사의 승낙으로 성립됩니다.</li>
                                <li>허위 정보 제공, 타인 정보 도용, 비정상적 목적 이용 시 가입이 제한될 수 있습니다.</li>
                                <li>만 14세 미만은 법정대리인 동의가 필요합니다.</li>
                                <li>회사는 역할(조직관리자, 강사, 학생 등)에 따라 기능 및 사용 한도를 다르게 설정할 수 있습니다.</li>
                            </ul>

                            <h2>제4조 (회원의 의무)</h2>
                            <p>회원은 다음 행위를 하여서는 안 됩니다.</p>
                            <ul>
                                <li>타인 정보 도용</li>
                                <li>저작권 및 지적재산권 침해</li>
                                <li>불법·유해 콘텐츠 게시</li>
                                <li>서비스 재판매·재배포</li>
                                <li>자동화 도구를 이용한 과도한 호출</li>
                                <li>보안 우회 및 비정상 트래픽 유발</li>
                            </ul>
                            <p>위반 시 서비스 이용이 제한될 수 있습니다.</p>

                            <h2>제5조 (계정 관리)</h2>
                            <p>아이디 및 비밀번호 관리 책임은 회원에게 있으며, 도용 발생 시 즉시 회사에 통지해야 합니다.</p>

                            <h2>제6조 (콘텐츠 권리)</h2>
                            <ul>
                                <li>회원이 업로드·생성한 콘텐츠의 권리는 원칙적으로 회원에게 있습니다.</li>
                                <li>회사는 서비스 운영·저장·보안·통계 목적 범위 내에서 해당 콘텐츠를 사용할 수 있습니다.</li>
                                <li>회원은 제3자의 권리를 침해하지 않아야 합니다.</li>
                            </ul>

                            <h2>제7조 (사용량 및 이용 제한)</h2>
                            <ul>
                                <li>회사는 안정적 운영을 위해 사용량(토큰, 호출 횟수 등)을 제한할 수 있습니다.</li>
                                <li>비정상 사용, 과도한 자동 호출, 보안 위협 발생 시 사전 통지 없이 이용이 제한될 수 있습니다.</li>
                                <li>회원은 예산·사용량 가드레일 기능을 활용하여 관리할 책임이 있습니다.</li>
                            </ul>

                            <h2>제8조 (외부 서비스 연동)</h2>
                            <ul>
                                <li>서비스는 OpenAI, Anthropic, Google 등 외부 AI 제공자의 API와 연동될 수 있습니다.</li>
                                <li>기능 수행을 위해 회원 입력 데이터가 외부 제공자에게 전송될 수 있습니다.</li>
                                <li>외부 제공자의 정책 변경·장애로 인한 영향에 대해 회사는 법령이 허용하는 범위 내에서 책임을 제한합니다.</li>
                            </ul>

                            <h2>제9조 (결제 및 환불)</h2>
                            <ul>
                                <li>유료 서비스는 서비스 내 안내된 방식으로 결제합니다.</li>
                                <li>이용 내역이 없는 경우 7일 이내 청약철회가 가능합니다.</li>
                                <li>이미 사용한 서비스에 대해서는 환불이 제한될 수 있습니다.</li>
                            </ul>

                            <h2>제10조 (면책사항)</h2>
                            <ul>
                                <li>LLM 출력물은 확률적 생성 결과로 정확성·완전성이 보장되지 않습니다.</li>
                                <li>회원은 출력 결과를 검증 후 사용해야 합니다.</li>
                                <li>회사는 불가항력, 외부 서비스 장애, 회원 귀책 사유로 인한 손해에 대해 법령이 허용하는 범위 내에서 책임을 제한합니다.</li>
                                <li>유료 회원의 경우 손해배상 한도는 최근 12개월간 지급한 이용대금 범위 내로 제한될 수 있습니다.</li>
                            </ul>

                            <h2>제11조 (계약 해지)</h2>
                            <p>회원은 언제든지 탈퇴할 수 있으며, 관련 법령에 따라 일부 정보는 일정 기간 보관될 수 있습니다.</p>

                            <h2>제12조 (준거법 및 관할)</h2>
                            <p>본 약관은 대한민국 법률에 따르며, 분쟁 발생 시 대한민국 법원을 관할 법원으로 합니다.</p>

                            <h2>부칙</h2>
                            <p>본 약관은 2026년 03월 05일부터 시행됩니다.</p>
                        </div>
                    </section>
                </main>

                <LandingFooter />
            </div>
        </>
    );
}
